import { ValuesOf } from '../utils/typeUtils';
import { DIRECTIONS, SKINS } from './Divider.constants';

export type DividerProps = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** The direction of the divider */
  direction?: DividerDirection;
  /** The skin of the divider */
  skin?: DividerSkin;
};

export type DividerDirection = ValuesOf<typeof DIRECTIONS>;
export type DividerSkin = ValuesOf<typeof SKINS>;
